import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OperationVenting = ({ value, onChange, patioDoorType, id = 'OperationVenting', label = 'Operation/Venting', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedOption, setSelectedOption] = useState(defaultValue);

    // Operation/Venting options based on patio door type
    const optionsByType = {
        Sliding: [
            { id: 1, value: 'XO(OSLI)', label: 'XO(OSLI)' },
            { id: 2, value: 'OX(OSLI)', label: 'OX(OSLI)' },
        ],
        TripleSliding: [
            { id: 1, value: 'OOX(OSLI)', label: 'OOX(OSLI)' },
            { id: 2, value: 'XOO(OSLI)', label: 'XOO(OSLI)' },
            { id: 3, value: 'O/XO(OSLI)', label: 'O/XO(OSLI)' },
            { id: 4, value: 'OX/O(OSLI)', label: 'OX/O(OSLI)' },
        ],
        QuadSliding: [
            { id: 1, value: 'OXXO', label: 'OXXO' },
            { id: 2, value: 'XOOO', label: 'XOOO' },
            { id: 3, value: 'OOOX', label: 'OOOX' },
        ],
    };

    // Get current door type value
    const doorTypeValue = patioDoorType?.value || 'Sliding';
    const options = optionsByType[doorTypeValue] || optionsByType.Sliding;

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedOption(value?.value || '');
    }, [value?.value]);

    // Reset to first option when door type changes (only if current value is not valid)
    useEffect(() => {
        if (options.length > 0) {
            const propValue = value?.value || selectedOption;
            const currentValueExists = options.some(opt => opt.value === propValue);
            if (!currentValueExists) {
                const defaultOption = options[0];
                setSelectedOption(defaultOption.value);
                onChange({ value: defaultOption.value, label: defaultOption.label });
            }
        }
    }, [doorTypeValue]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (options.length > 0 && !selectedOption) {
            const defaultOption = options[0];
            setSelectedOption(defaultOption.value);
            onChange({ value: defaultOption.value, label: defaultOption.label });
        }
    }, []);

    const handleChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');
        setSelectedOption(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedOption}
                onChange={handleChange}
            >
                {options.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedOption === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default OperationVenting;
